var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "11px",
    viewBox: "0 0 7 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home---Multiple",
    transform: "translate(-1344.000000, -142.000000)",
    fill: "#121212",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Side-Bar",
    transform: "translate(849.000000, 90.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Current-Building-Selected",
    transform: "translate(102.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Go-to-Main-Dashboard",
    transform: "translate(219.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.967562,16.7665148 L177.495526,20.3018223 L174.02349,16.7665148 C173.674497,16.4111617 173.110738,16.4111617 172.761745,16.7665148 C172.412752,17.1218679 172.412752,17.6958998 172.761745,18.0512528 L176.869128,22.2334852 C177.218121,22.5888383 177.781879,22.5888383 178.130872,22.2334852 L182.238255,18.0512528 C182.587248,17.6958998 182.587248,17.1218679 182.238255,16.7665148 C181.889262,16.4202733 181.316555,16.4111617 180.967562,16.7665148 L180.967562,16.7665148 Z",
    id: "Path",
    transform: "translate(177.500000, 19.500000) rotate(-90.000000) translate(-177.500000, -19.500000) "
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDark);
export default __webpack_public_path__ + "static/media/arrow-dark.4507bba935ef110dad9dafd1958747f9.svg";
export { ForwardRef as ReactComponent };